<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
      </div>
      <div>
        <h2 class="modal-title">Editar tarefa</h2>
        <p class="modal-subtitle">Modifique os detalhes da tarefa conforme necessário</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="info-box" *ngIf="contatoInfo?.nome">
      <div class="info-linha">
        <span class="info-nome-destaque">{{ contatoInfo.nome }}</span>
        <span class="info-cargo">{{ contatoInfo.cargo }}</span>
      </div>
      <div class="info-empresa" *ngIf="contatoInfo.email">{{ contatoInfo.email }}</div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="responsavel">
          Responsável <span class="required">*</span>
        </label>
        <app-filtro-responsavel
          [responsaveis]="responsavel"
          [value]="responsibleID"
          (valueChange)="responsibleID = $event"
          placeholder="Selecione o responsável"
          placeholderBusca="Buscar responsável"
        ></app-filtro-responsavel>
      </div>

      <div class="form-group">
        <label class="form-label" for="tarefa">
          Tipo de tarefa <span class="required">*</span>
        </label>
        <select
          id="tarefa"
          [(ngModel)]="actionID"
          class="form-select"
        >
          <option value="" disabled>Selecione a tarefa</option>
          <option *ngFor="let t of tarefas" [value]="t.id">{{ t.description }}</option>
        </select>
      </div>
    </div>

    <div class="form-row form-row--data">
      <div class="form-group">
        <label class="form-label" for="data">
          Data
        </label>
        <input
          id="data"
          type="date"
          [(ngModel)]="data"
          class="form-input"
          [min]="today"
        />
      </div>
      <div class="form-group">
        <label class="form-label" for="hora">
          Hora
        </label>
        <input
          id="hora"
          type="time"
          [(ngModel)]="hora"
          class="form-input"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="descricao">Anotação (opcional)</label>
      <textarea
        id="descricao"
        [(ngModel)]="descricao"
        class="form-textarea"
        rows="3"
        maxlength="2000"
        placeholder="Descreva a anotação..."
      ></textarea>
      <div class="textarea-footer">
        <span class="char-count">{{ descricao.length }}/2000</span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="fechar()">
      Cancelar
    </button>
    <button class="btn-primary" type="button" (click)="editarTarefa()">
      <mat-icon>check</mat-icon>
      Salvar alterações
    </button>
  </div>
</div>
